import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedSpace = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictedSpace" */ '../src/RestrictedSpace.tsx'))
			.RestrictedSpace,
});
